module.exports = __webpack_public_path__ + "img/001-compliant.24b34b78.png";